import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { CenteredFlexColumn, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const CUSTOM_MODAL_STYLES = {
    content: { padding: "42px 64px", width: 620, minHeight: 360 },
};

export const StyledMainContainer = styled(FlexColumn)`
    flex-grow: 1;
`;

export const StyledButtonsContainer = styled(CenteredFlexColumn)`
    row-gap: 8px;
    padding-top: 32px;
`;

export const StyledImg = styled.img`
    align-self: center;
    height: 94px;
    width: 94px;
`;

export const StyledTitle = styled.h6`
    ${mixins.setFontVariant("h6", colorsPalettes.carbon["500"])};

    margin: 0;
    text-align: center;
`;

export const StyledSubtitle = styled.p`
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["500"])};

    margin: 8px 0 0;
    text-align: center;
`;
